import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { rem } from 'polished'
import Brandy from '../Brandy'
import List from '../List'

export const PriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;

  .nutrition {
    font-size: 12px;
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const Before = styled.span(
  ({ theme, inPackageCard }) => css`
    font-size: 14px;
    display: block;
    text-align: ${inPackageCard &&
    theme?.components?.PackageCard?.alignment === 'center'
      ? 'center'
      : 'left'};
    width: ${inPackageCard &&
    theme?.components?.PackageCard?.alignment === 'left'
      ? '100%'
      : 'auto'};

    // This fixes the alignment of the duration when it is under the price inside of a block
    ${!inPackageCard &&
    `
      text-align: left;
      margin-left: 0;
      width: 100%;
    `}
  `
)

export const Price = styled.div(({ styles, theme, large, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  } else {
    color = 'inherit'
  }

  return css`
    font-size: ${large
      ? rem(theme.fonts.headings.lg?.size[1] * 1.5)
      : rem(theme.fonts.headings.lg?.size[1])};

    .leshen-brandy {
      text-align: ${inPackageCard &&
      theme?.components?.PackageCard?.alignment === 'center'
        ? 'center'
        : 'left'};
      margin: ${styles === 'Duration Under Price'
        ? `0px ${theme.spacing.sm} ${theme.spacing.sm}`
        : '0'};
    }

    .price-old {
      color: ${color} !important;
      margin-left: 0;
      margin-right: 0;
    }
  `
})

export const AmountWrapper = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    width: fit-content;
  `
)

export const Currency = styled.span(({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  } else {
    color = 'inherit'
  }

  return css`
    font-family: ${theme?.fonts?.headings?.family ||
    theme?.fonts?.body?.family};
    font-size: ${theme?.components?.Price?.dollarSign?.size
      ? theme?.components?.Price?.dollarSign?.size
      : '1em'};
    line-height: 1;
    margin-right: 2px;

    font-weight: ${theme?.components?.Price?.dollarSign?.weight || 'bold'};

    color: ${color} !important;

    transform: translateY(
        ${theme?.components?.Price?.dollarSign?.offsetY || '0px'}
      )
      translateX(${theme?.components?.Price?.dollarSign?.offsetX || '0px'});
  `
})

export const DollarAmount = styled.span(({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  }

  return css`
    font-family: ${theme?.fonts?.headings?.family ||
    theme?.fonts?.body?.family};
    line-height: 1;
    font-weight: ${theme?.components?.Price?.dollar?.weight || 'bold'};

    color: ${color} !important;

    font-size: ${theme?.components?.Price?.dollar?.size || 'inherit'};
  `
})

export const SymbolAndDollarAmountStyles = ({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  }

  return css`
    display: flex;

    span {
      color: ${color} !important;
    }
  `
}

export const SymbolAndDollarAmount = styled.div(SymbolAndDollarAmountStyles)

export const ChangeAmountStyles = ({ theme, inPackageCard }) => {
  const alignSelf = {
    underCents: 'flex-start',
    underPrice: 'flex-start',
    top: 'flex-start',
    bottom: 'flex-end',
    center: 'center',
    default: 'flex-end',
  }

  const flexDirection = {
    underCents: 'column',
    default: 'row',
  }

  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  } else {
    color = 'inherit'
  }

  return css`
    color: ${color} !important;
    line-height: 1;
    width: fit-content;
    display: flex;
    font-weight: ${theme?.components?.Price?.cents?.weight || 'bold'};
    font-family: ${theme?.fonts?.headings?.family ||
    theme?.fonts?.body?.family};
    align-self: ${theme?.components?.Price?.duration?.position === 'underCents'
      ? alignSelf[theme?.components?.Price?.duration?.position]
      : alignSelf[theme?.components?.Price?.cents?.position] ||
        alignSelf.default};

    font-size: ${theme?.components?.Price?.cents?.size ||
    theme?.components?.Price?.duration?.position === 'underCents'
      ? theme?.components?.Price?.cents?.size || '0.4em'
      : '1em'};

    flex-direction: ${flexDirection[
      theme?.components?.Price?.duration?.position
    ] || flexDirection.default};

    transform: translateY(${theme?.components?.Price?.cents?.offsetY || '0px'})
      translateX(${theme?.components?.Price?.cents?.offsetX || '0px'});

    .decimal {
      font-weight: normal;
    }

    > * {
      color: ${color} !important;
    }
  `
}

export const ChangeAmount = styled.span(ChangeAmountStyles)

export const DurationStyles = ({ theme, inPackageCard }) => {
  const alignSelf = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
    underPrice: `${
      theme?.components?.PackageCard?.alignment === 'center'
        ? 'center'
        : 'flex-start'
    }`,
    default: 'flex-end', // default
  }

  const marginLeft = {
    underCents: '0px',
    underPrice: '0px',
    default: '4px',
  }

  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  }

  if (inPackageCard) {
    color =
      theme?.components?.PackageCard?.color ||
      theme?.components?.Price?.duration?.color ||
      'black'
  }

  return css`
    font-size: ${theme?.components?.Price?.duration?.size ||
    (theme?.components?.Price?.duration?.position === 'underCents' &&
      theme?.components?.Price?.cents?.size) ||
    '0.4em'};
    line-height: ${theme?.components?.Price?.duration?.lineHeight || 1};
    font-family: ${theme?.components?.Price?.duration?.fontFamily ||
    theme?.fonts?.body?.family};
    opacity: ${theme?.components?.Price?.duration?.opacity || '1'};
    align-self: ${alignSelf[theme?.components?.Price?.duration?.position] ||
    'flex-end'};
    font-weight: ${theme?.components?.Price?.duration?.weight || 'bold'};
    margin-left: ${marginLeft[theme?.components?.Price?.duration?.position] ||
    marginLeft.default};

    transform: translateY(
        ${theme?.components?.Price?.duration?.offsetY || '0px'}
      )
      translateX(${theme?.components?.Price?.duration?.offsetX || '0px'});

    color: ${theme?.components?.Price?.color ||
    (theme?.components?.Price?.duration?.color && // eslint-disable-line no-nested-ternary
      theme?.components?.Price?.duration?.position === 'underCents') ||
    theme?.components?.Price?.duration?.position === 'underPrice'
      ? `${theme?.components?.Price?.color} !important`
      : 'inherit !important'};

    // This fixes the alignment of the duration when it is under the price inside of a block

    ${theme?.components?.Price?.duration?.position === 'underPrice' &&
    !inPackageCard &&
    `
      text-align: left;
      margin-left: 0;
    `}
    ${theme?.components?.Price?.duration?.position === 'underPrice' &&
    `
      width: 100%;
    `}

    .duration-html {
      display: block;
      color: ${color} !important;
    }
  `
}

export const Duration = styled.span(DurationStyles)

export const DividerStyles = ({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  } else {
    color = 'inherit'
  }

  const marginBottom = {
    underCents: '2px',
    default: '0',
  }

  const marginTop = {
    underCents: '2px',
    default: '0',
  }

  return css`
    content: ' ';
    width: 100%;
    display: block;
    height: 2px;
    background-color: ${color} !important;
    margin-top: ${marginTop[theme?.components?.Price?.duration?.position] ||
    marginTop.default};
    margin-bottom: ${marginBottom[
      theme?.components?.Price?.duration?.position
    ] || marginBottom.default};
  `
}

export const Divider = styled.span(DividerStyles)

export const Suffix = styled.span`
  font-size: 1rem;
`

export const CentsAndDuration = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 4px;
`

export const DisclaimerStyles = ({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  } else {
    color = 'inherit'
  }

  return css`
    display: flex;
    flex-direction: column;

    .modal {
      font-size: 0.625rem;
      line-height: 0.75rem;
      opacity: 0.8;
      color: ${color} !important;
    }
  `
}

export const DisclaimersWrapper = styled.span(DisclaimerStyles)

export const Bullets = styled(List)`
  margin: ${({ theme }) => theme.spacing.sm};
  margin-left: 0;
`
export const Disclaimer = styled(Brandy)`
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
`
